import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment, Button, Dialog, DialogTitle, DialogContent, Menu, MenuItem, ListItemText, ListItemIcon } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from '../../../../routes/paths';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import ConfirmationPopup from '../../official-request/ConfirmationPopup';
import { useState } from 'react';
import { sentenceCase } from 'change-case'
import { BlockOutlined, TaskAltOutlined, Close, QrCodeScanner } from '@material-ui/icons';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme, noPadding }) => ({
  height: noPadding ? 0 : 96,
  display: 'flex',
  justifyContent: 'space-between',
  ...(noPadding && {
    padding: 0
  }),
  ...(!noPadding && {
    padding: theme.spacing(0, 1, 0, 3)
  }),
  '@media (min-width: 600px)': {
    height: noPadding ? 0 : 96,
    padding: noPadding ? 0 : theme.spacing(0, 1, 0, 3)
  }
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 260, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

ProductToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  noPadding: PropTypes.bool
};

export default function ProductToolbar({ numSelected, filterName, onFilterName,selected,onDelete,selectedName,item,rowCount,userId,onUpdateList,selectedTab,showActiveInactive,setRefreshData,refreshData, openQRScanner, setOpenQRScanner, qrSearched, onClearQRSearch, qrSearchValue, qrShow = false, onMoveSelected, onStatusChange, noPadding = false }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [openDeletePop,setOpenDeletePop] = useState(false);
  const [openactivatePop, setOpenActivatePop] = useState(false);
  const [moveAnchorEl, setMoveAnchorEl] = useState(null);
  const [moveTarget, setMoveTarget] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  let materialStatus = (selectedTab ==="inactive_catalogs" || selectedTab=='inactive_services') ? 1 : 0
  const [deleteConfirmationMessage,setDeleteConfirmationMessage] = useState()
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions

let hasPermission = ''
  if(item === "contacts"){
    hasPermission = explodedPermissions?.some(permission => ['Delete Contact'].includes(permission)) ? true : false
  }
  else if(item === "catalogs"){
    hasPermission = explodedPermissions?.some(permission => ['Delete Catalog'].includes(permission)) ? true : false
  }
  else if(item === "opportunities"){
    hasPermission = explodedPermissions?.some(permission => ['Delete Opportunity'].includes(permission)) ? true : false
  }
  else if(item === "leads"){
    hasPermission = explodedPermissions?.some(permission => ['Delete Lead'].includes(permission)) ? true : false
  }
  else if(item === "lead statuses"){
    hasPermission = explodedPermissions?.some(permission => ['Delete Lead Status'].includes(permission)) ? true : false
  }
  else if(item === "services"){
    hasPermission = explodedPermissions?.some(permission => ['Delete Catalog'].includes(permission)) ? true : false
  }

  const changeStatus = async (deleteId, deleteStatus,activate) => {
    try {
      let id = deleteId;
      let status = deleteStatus;
      let response;
      // console.log("id-----", id, " status-----------", status)
        if (item === "catalogs" && activate) {
              response = await axios.post((`${REST_API_END_POINT}product/delete-product?id=${id}&status=${status}`))
            }
           else if(item === "contacts"){
        response = await axios.post(`${REST_API_END_POINT}contacts/delete-contact`,{contactId:id,status})
      }
      else if(item === "catalogs"){
        response = await axios.post((`${REST_API_END_POINT}product/delete-product?id=${id}&status=${status}`))
      }
      else if(item === "opportunities"){
        response = await axios.post(`${REST_API_END_POINT}opportunities/delete-opportunity`,{deleteId:id,status,userId})
      }
      else if(item === "leads"){
        response = await axios.post(`${REST_API_END_POINT}leads/delete-lead`,{updateId:id,status,userId})
      }
      else if(item === "lead statuses"){
        response = await axios.post(`${REST_API_END_POINT}leads/delete-lead-status`,{deleteId:id,status,userId})
      }
      else if(item === "services"){
        response = await axios.post(`${REST_API_END_POINT}product/delete-labour-cost-services`,{id,status,userId})
      }
      // console.log("response-----------------", response.data);
      return response.data;
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }

  const handleMenuItemClick = async (selectedIds, newStatus,activate) => {
    try{
      setOpenDeletePop(false);
      setOpenActivatePop(false)

      const result = await Promise.all(selectedIds.map((id) => changeStatus(id, newStatus,activate)));
      // console.log("deleted data length",result.length);
      if (selectedIds.length === result.length){
        onDelete();
        if(activate){

          enqueueSnackbar(`${result.length} ${item} ${selectedTab=='inactive_catalogs'? "Activated" :"Deactivated"}`,
             { variant: 'success' });
          if (onStatusChange) {
            onStatusChange(selectedIds);
          }
        }else{
        enqueueSnackbar(`${result.length} ${item} deleted`, { variant: 'success' });
        }
        if(item === "contacts"){
          onUpdateList(result)
          // navigate(PATH_DASHBOARD.crm.contact, { state: { data: result } });
        }
        else if(item === "catalogs"){
          navigate(PATH_DASHBOARD.products.main, { state: { data: result } });
        }
        else if(item === "opportunities"){
          // navigate(PATH_DASHBOARD.crm.opportunity, { state: { data: result}});
        }
        else if(item === "leads"){
          onUpdateList(result)
          // navigate(PATH_DASHBOARD.crm.lead, { state: { data: result}});
        }
        else if(item === "lead statuses"){
          onUpdateList(result)
          // navigate(PATH_DASHBOARD.crm.leadstatus, { state: { data: result}});
        }
        else if(item === "services"){
          // navigate(PATH_DASHBOARD.labour.main, { state: { data: result } });
          setRefreshData(!refreshData)
        }
      }
      else {
        console.log("Error.........!");
        enqueueSnackbar(`Unable to delete the ${item}.!`, { variant: 'error' });
      }
    }
    catch(error){
      console.log("Server error",error);
    }
  }
  const wordCount = filterName?.trim().split(/\s+/).filter(Boolean).length || 0;
  const isOverLimit = wordCount > 25;
  const selectionLabel = numSelected ? (rowCount && numSelected === rowCount ? 'all ' : `${numSelected} `) : '';
  const movableTabs = item === 'services'
    ? ['in_house', 'sub_contract', 'install', 'ts', 'estimate_services', 'design_services', 'admin_services']
    : ['in_house', 'in_stock_catalog', 'client_owned_catalog', 'traffic_catalog', 'split_catalog', 'sub_contract', 'estimate_catalog'];

  const serviceMoveOptions = [
    { value: 1, label: 'Production' },
    { value: 0, label: 'Sub Contract' },
    { value: 2, label: 'Install' },
    { value: 3, label: 'T/S' },
    { value: 4, label: 'Estimate Services' },
    { value: 5, label: 'Design Services' },
    { value: 6, label: 'Admin Services' },
  ];

  const catalogMoveOptions = [
    { value: 'in_house', label: 'Production Catalog' },
    { value: 'in_stock_catalog', label: 'In Stock Catalog' },
    { value: 'client_owned_catalog', label: 'Client Owned Catalog' },
    { value: 'traffic_catalog', label: 'Traffic Catalog' },
    { value: 'sub_contract', label: 'Sub Contract' },
    { value: 'estimate_catalog', label: 'Estimate Catalog' },
  ];

  const moveOptions = item === 'services' ? serviceMoveOptions : catalogMoveOptions;

  // Use the same icon classes shown in row menu for consistency
  const serviceOptionIcons = {
    1: 'ic--outline-move-down', // Production
    0: 'hugeicons--square-arrow-move-right-up', // Sub Contract
    2: 'hugeicons--circle-arrow-move-up-right', // Install
    3: 'ic--sharp-move-up', // T/S
    4: 'hugeicons--circle-arrow-move-up-right', // Estimate Services
    5: 'hugeicons--circle-arrow-move-up-right', // Design Services
    6: 'hugeicons--circle-arrow-move-up-right', // Admin Services
  };

  const catalogOptionIcons = {
    in_stock_catalog: 'ic--sharp-move-up',
    client_owned_catalog: 'hugeicons--circle-arrow-move-up-right',
    traffic_catalog: 'material-symbols--moved-location-rounded',
    split_catalog: 'tabler--arrow-move-right',
    sub_contract: 'hugeicons--square-arrow-move-right-up',
    in_house: 'ic--outline-move-down',
    estimate_catalog: 'hugeicons--circle-arrow-move-up-right',
  };

  const optionIcons = item === 'services' ? serviceOptionIcons : catalogOptionIcons;

  const getTabValue = (tab) => {
    if (item === 'services') {
      const tabToValueMap = {
        'in_house': 1,
        'sub_contract': 0,
        'install': 2,
        'ts': 3,
        'estimate_services': 4,
        'design_services': 5,
        'admin_services': 6,
        'inactive_services': null
      };
      return tabToValueMap[tab];
    }
    return tab;
  };

  const availableMoveOptions = moveOptions.filter((option) => {
    const currentValue = getTabValue(selectedTab);
    return item === 'services' ? option.value !== currentValue : option.value !== selectedTab;
  });

  const canMove = movableTabs.includes(selectedTab);

  const searchBarBg = isLight ? theme.palette.grey[200] : 'var(--signwise-app-chrome-toolbar)';
  const searchBarFg = isLight ? theme.palette.text.primary : theme.palette.common.white;

  return (
    <RootStyle
      noPadding={noPadding}
      sx={{
        ...(numSelected > 0 && {
          color: 'text.primary',
          bgcolor: isLight ? theme.palette.grey[200] : 'var(--signwise-app-chrome-toolbar)'
        })
      }}
    >
  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <SearchStyle
        sx={{
          backgroundColor: searchBarBg,
          color: searchBarFg,
          '& .MuiOutlinedInput-input': {
            color: searchBarFg
          },
          '& .MuiOutlinedInput-input::placeholder': {
            color: isLight ? theme.palette.text.secondary : alpha(theme.palette.common.white, 0.5),
            opacity: 1
          },
          ...(isOverLimit && {
            '& fieldset': {
              borderColor: theme.palette.error.main + ' !important'
            }
          })
        }}
          value={isEditing ? filterName : (qrSearchValue || filterName)}
          onChange={(e) => {
            const input = e.target.value;
            const words = input.trim().split(/\s+/).filter(Boolean);
          
            // Mark as editing when user starts typing
            if (!isEditing && qrSearchValue && input !== qrSearchValue) {
              setIsEditing(true);
            }
          
            if (words.length <= 25) {
              onFilterName(e);
            } else {
              const trimmedInput = words.slice(0, 25).join(' ') + ' ';
              const syntheticEvent = {
                ...e,
                target: {
                  ...e.target,
                  value: trimmedInput
                }
              };
              onFilterName(syntheticEvent);
            }
          }}
          onFocus={() => {
            // When user focuses, if there's a qrSearchValue, sync filterName and mark as editing
            if (qrSearchValue && !isEditing) {
              // Sync filterName with qrSearchValue if they don't match
              if (filterName !== qrSearchValue) {
                const syntheticEvent = {
                  target: {
                    value: qrSearchValue
                  }
                };
                onFilterName(syntheticEvent);
              }
              setIsEditing(true);
            }
          }}
          placeholder= {`Search ${sentenceCase(item)}...`}
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
          endAdornment={
            <>
              {qrShow ? (
                <>
                  {(qrSearched || filterName) ? (
                    <Tooltip title="Clear Search">
                      <IconButton size="small" onClick={() => {
                        setIsEditing(false);
                        onClearQRSearch();
                      }}>
                        <Close />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <>
                      <Typography variant='subtitle2' color='text.disabled' sx={{ px: 1 }}>OR</Typography>
                      <IconButton size='small' onClick={() => setOpenQRScanner(true)}>
                        <QrCodeScanner sx={{ fontSize: "30px" }} />
                      </IconButton>
                    </>
                  )}
                  <Dialog open={openQRScanner} onClose={() => setOpenQRScanner(false)}>
                    <DialogTitle>Scan QR Code</DialogTitle>
                    <DialogContent>
                      <div id="reader" style={{ width: "100%" }}></div>
                    </DialogContent>
                  </Dialog>
                </>
              ) : ''}
            </>
          }
        />
        {isOverLimit && (
        <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
          Maximum 25 words allowed.
        </Typography>
      )}
        </Box>
      {numSelected > 0 && (
        <Typography component="div" variant="subtitle1" sx={{ ml: 1, mr: 1.5 }}>
          {numSelected} selected
        </Typography>
      )}
    

      {(numSelected > 0 && hasPermission && showActiveInactive) && (
        <Tooltip
        title={(selectedTab=="inactive_catalogs" || selectedTab=='inactive_services') ? 'Activate' : 'Deactivate'}
        onClick={()=>{ setOpenActivatePop(true);;
          // {console.log("numSelected",numSelected,"rowCount",rowCount);}
          if (numSelected === rowCount){
          setDeleteConfirmationMessage(" all ")
          }else if (numSelected){
            setDeleteConfirmationMessage(` ${numSelected} `)
          }
        }}>
          {/* <IconButton >
            {(selectedTab=="inactive_catalogs" || selectedTab=='inactive_services')? <TaskAltOutlined sx={{ width: 25, height: 25 }} />: <BlockOutlined sx={{ width: 25, height: 25 }} />}
          </IconButton> */}
        
        <Button
  variant="contained" 
  color={(selectedTab === "inactive_catalogs" || selectedTab === "inactive_services") ? "success" : "error"}
  onClick={() => {
    setOpenActivatePop(true);
    if (numSelected === rowCount) {
      setDeleteConfirmationMessage(" all ");
    } else if (numSelected) {
      setDeleteConfirmationMessage(` ${numSelected} `);
    }
  }}
  sx={{ display: 'flex', alignItems: 'center', gap: 1, textTransform: 'none', padding: '6px 12px' }} // Custom styling
>
  {(selectedTab === "inactive_catalogs" || selectedTab === "inactive_services") ? 
    <TaskAltOutlined sx={{ width: 20, height: 20 }} /> : 
    <BlockOutlined sx={{ width: 20, height: 20 }} />
  }
  <Typography variant="body2">
    {(selectedTab === "inactive_catalogs" || selectedTab === "inactive_services") ? "Activate" : "Deactivate"}
  </Typography>
</Button>


        </Tooltip>
      )} 

      {(numSelected > 0 && (item === "catalogs" || item === "services") && canMove) && (
        <>
          <Button
            variant="contained"
            color="primary"
            startIcon={<span className="hugeicons--square-arrow-move-right-up" style={{ fontSize: 18 }} />}
            sx={{ textTransform: 'none', ml: 1, boxShadow: theme.customShadows?.primary, fontWeight: 600 }}
            onClick={(e) => setMoveAnchorEl(e.currentTarget)}
          >
            Move
          </Button>
          <Menu
            anchorEl={moveAnchorEl}
            open={Boolean(moveAnchorEl)}
            onClose={() => setMoveAnchorEl(null)}
          >
            {availableMoveOptions.map((option) => (
              <MenuItem
                key={option.value}
                onClick={() => {
                  setMoveAnchorEl(null);
                  setMoveTarget(option);
                  if (numSelected === rowCount) {
                    setDeleteConfirmationMessage(" all ");
                  } else if (numSelected) {
                    setDeleteConfirmationMessage(` ${numSelected} `);
                  }
                }}
              >
                <ListItemIcon sx={{ minWidth: 34 }}>
                  <span className={optionIcons[option.value]} style={{ fontSize: 20, display: 'inline-flex' }} />
                </ListItemIcon>
                <ListItemText primary={`Move to ${option.label}`} primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>
            ))}
          </Menu>
        </>
      )}

{(numSelected > 0 && hasPermission) && (
        <Tooltip title="Delete"
        onClick={()=>{setOpenDeletePop(true);
          // {console.log("numSelected",numSelected,"rowCount",rowCount);}
          if (numSelected === rowCount){
          setDeleteConfirmationMessage(" all ")
          }else if (numSelected){
            setDeleteConfirmationMessage(` ${numSelected} `)
          }
        }}>
          <IconButton >
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      )} 


      {/* Confirmation for deleting multiple */}
      <ConfirmationPopup
        open={openDeletePop}
        handleClose={()=>{setOpenDeletePop(false)}}
        message={`You want to delete ${deleteConfirmationMessage} ${item} ! `}
        // message={`You want to delete : ${selectedName.join(', ')} !`}
        handleClick={() => handleMenuItemClick(selected, 2)}
      />
      <ConfirmationPopup
        open={openactivatePop}
        handleClose={()=>{setOpenActivatePop(false)}}
        message={`You want to ${(selectedTab==="inactive_catalogs" || selectedTab=='inactive_services') ? "Activate" : "Deativate"} ${deleteConfirmationMessage} ${item} ! `}
        // message={`You want to delete : ${selectedName.join(', ')} !`}
        handleClick={() => handleMenuItemClick(selected, materialStatus,1)}
      />
      <ConfirmationPopup
        open={!!moveTarget}
        handleClose={()=>{setMoveTarget(null)}}
        message={`You want to move ${selectionLabel}${item === 'services' ? 'service' : 'catalog'}${numSelected > 1 ? 's' : ''} to ${moveTarget?.label}? `}
        handleClick={() => {
          if (onMoveSelected && moveTarget?.value !== undefined && moveTarget?.value !== null) {
            onMoveSelected(moveTarget.value);
          }
          setMoveTarget(null);
        }}
      />

    </RootStyle>
  );
}
